/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

const CardTitleImage = props => (
  <img
    className="mission-title-card"
    {...props}
  />
);

export default CardTitleImage;
